module.exports = __webpack_public_path__ + "media/images/icons/icn_008-1cec0ee95fb65e3f12b15fcbe2e2e5e8.svg";